export default __webpack_public_path__ + "static/media/michele-circle.71f1294f.png";